import { render } from "./AwardsPage.vue?vue&type=template&id=38a310c3&scoped=true"
import script from "./AwardsPage.vue?vue&type=script&lang=js"
export * from "./AwardsPage.vue?vue&type=script&lang=js"

import "./AwardsPage.vue?vue&type=style&index=0&id=38a310c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a310c3"]])

export default __exports__